import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'uex-layout-sidebar-header',
  templateUrl: './header.component.html',
  host: {
    class: 'uex-layout-sidebar-header'
  }
})

export class LayoutSidebarHeaderComponent implements OnInit {

  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
